import React, { useState } from 'react';
import { JobDescription } from '../../../../../../../../utils/types/JobOpenings';
import { STARSCORING } from '../Constants';

interface Props {
  jobDescription?: JobDescription;
  onGenerateQuestions: (selectedAttributes: string[]) => void;
}

export const BEIAttributesSidebar = ({
  jobDescription,
  onGenerateQuestions,
}: Props) => {
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);

  const handleAttributeToggle = (attribute: string) => {
    setSelectedAttributes((prev) =>
      prev.includes(attribute)
        ? prev.filter((attr) => attr !== attribute)
        : [...prev, attribute],
    );
  };

  const handleGenerateClick = () => {
    if (selectedAttributes.length > 0) {
      onGenerateQuestions(selectedAttributes);
    }
  };

  return (
    <div className='w-full h-full bg-primary-background/30 border border-primary-dark/40 rounded-[10px] p-3 sm:p-4 lg:max-w-xs'>
      <h2 className='font-medium text-primary-main'>BEI Attributes</h2>
      <div className='mt-3 sm:mt-5'></div>

      { /* Display attributes from job description behavioral attributes */ }
      { jobDescription?.behavioralAttributes &&
        jobDescription.behavioralAttributes.length > 0 && (
        <div className='flex flex-col gap-3 mb-5 sm:mb-6'>
          <p className='text-xs text-gray-600 mb-2'>
            Select attributes to generate questions:
          </p>
          <div className='flex max-h-52 flex-col gap-3 overflow-y-auto pr-1 lg:max-h-none lg:overflow-visible lg:pr-0'>
            { jobDescription.behavioralAttributes.map((attribute, index) => (
              <label
                  key={index}
                  className='flex items-start gap-3 cursor-pointer group'
              >
                <input
                    type='checkbox'
                    checked={selectedAttributes.includes(attribute)}
                    onChange={() => handleAttributeToggle(attribute)}
                    className='mt-0.5 w-4 h-4 text-primary-main bg-gray-100 border-gray-300 rounded focus:ring-primary-main focus:ring-2'
                />
                <span className='text-sm font-medium text-primary-dark group-hover:text-primary-main transition-colors'>
                  { attribute }
                </span>
              </label>
            )) }
          </div>

          { /* Generate Button */ }
          <button
              onClick={handleGenerateClick}
              disabled={selectedAttributes.length === 0}
              className={`mt-4 w-full py-2 px-4 rounded-lg text-sm font-medium transition-all ${
                selectedAttributes.length > 0
                  ? 'bg-primary-main text-white hover:bg-primary-main/90 hover:shadow-md'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              }`}
          >
            Generate Questions ({ selectedAttributes.length })
          </button>
        </div>
      ) }

      { /* STAR SCORING METHODOLOGY */ }
      <div className='flex flex-col gap-4'>
        <p className='text-sm text-primary-main font-medium'>
          STAR Scoring Methodology
        </p>
        { /* star scoring label */ }
        { STARSCORING.map((item) => (
          <div key={item.label}>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 rounded-full bg-primary-dark/20 flex items-center justify-center'>
                <div className='w-2 h-2 rounded-full bg-primary-dark' />
              </div>
              <div className='flex w-full items-center justify-between'>
                <span className='text-sm text-primary-text uppercase'>
                  { item.label }
                </span>
                <span className='text-sm text-primary-dark font-semibold'>
                  { item.value }%
                </span>
              </div>
            </div>
          </div>
        )) }
      </div>
    </div>
  );
};
